import FBody from '@/plugins/form/FBody';
import FEditor from '@/plugins/form/FEditor';
import FTextarea from '@/plugins/form/FTextarea';
import FGallery from '@/plugins/form/FGallery';
import FAvatar from '@/plugins/form/FAvatar';

export default class extends FBody {
  min = new FTextarea({
    label: 'Краткое описание',
    autosize: {
      minRows: 1,
      maxRows: 6,
    },
  });

  preview = new FAvatar({
    label: 'Изображение для поиска',
  });

  gallery = new FGallery({
    label: 'Галерея',
  });

  program = new FEditor({
    label: 'Программа тура',
  });

  condition = new FEditor({
    label: 'Условия',
  });

  cancellation = new FEditor({
    label: 'Аннуляция',
  });

  constructor(props = {}) {
    super(props);
    this.tour = props.parent;
    this.setItems([
      ['min', this.min],
      ['preview', this.preview],
      ['gallery', this.gallery],
      ['program', this.program],
      ['condition', this.condition],
      ['cancellation', this.cancellation],
    ]);
    this.set();
  }

  get data() {
    const data = super.data;
    return {
      ShortDescription: data.min || '',
      FullDescription: data.condition || '',
      TourConditions: data.program || '',
      CancellationConditions: data.cancellation || '',
      ImagesInfo: {
        ImagesUrls: data.gallery || [],
        PreviewImageUrl: data.preview || '',
      },
    };
  }

  set data(data) {
    this.min.set(data?.ShortDescription || '');
    this.condition.set(data?.FullDescription || '');
    this.program.set(data?.TourConditions || '');
    this.cancellation.set(data?.CancellationConditions || '');
    this.gallery.set(data?.ImagesInfo?.ImagesUrls || []);
    this.preview.set(data?.ImagesInfo?.PreviewImageUrl || '');
  }

  set(value = {}) {
    this.min.set(value.min || '');
    this.preview.set(value.preview || '');
    this.gallery.set(value.gallery || []);
    this.program.set(value.program || '');
    this.condition.set(value.condition || '');
    this.cancellation.set(value.cancellation || '');
    return this;
  }
}
